import ruBase from './locales/ru.json';
import kzBase from './locales/kk.json';

export const messages = {
  ru: {
    ...ruBase,
  },
  kz: {
    ...kzBase,
  }
};

export function getMessagesByLocale(locale) {
  return locale === 'kz' ? messages.kz : messages.ru;
}
